import { registerEnum } from '@cbbt/lib-interface';
var TradingStatus;
(function (TradingStatus) {
    TradingStatus["ACTIVE"] = "ACTIVE";
    TradingStatus["ADMINISTRATOR_APPOINTMENT"] = "ADMINISTRATOR_APPOINTMENT";
    TradingStatus["ADMINISTRATOR_DISCHARGE"] = "ADMINISTRATOR_DISCHARGE";
    TradingStatus["COMPANY_DISSOLVED_LCST"] = "COMPANY_DISSOLVED_LCST";
    TradingStatus["COMPANY_DISSOLVED_S353"] = "COMPANY_DISSOLVED_S353";
    TradingStatus["COMPANY_REINSTATED"] = "COMPANY_REINSTATED";
    TradingStatus["COMPULSORY_LIQUIDATION"] = "COMPULSORY_LIQUIDATION";
    TradingStatus["CONVERTED_CREDITORS_VOLUNTARY_LIQUIDATION"] = "CONVERTED_CREDITORS_VOLUNTARY_LIQUIDATION";
    TradingStatus["CREDITOR_MEETING"] = "CREDITOR_MEETING";
    TradingStatus["CREDITORS_VOLUNTARY_LIQUIDATION"] = "CREDITORS_VOLUNTARY_LIQUIDATION";
    TradingStatus["DORMANT"] = "DORMANT";
    TradingStatus["INTENTION_TO_DISSOLVE"] = "INTENTION_TO_DISSOLVE";
    TradingStatus["LIQUIDATION"] = "LIQUIDATION";
    TradingStatus["MEMBERS_VOLUNTARY_LIQUIDATION"] = "MEMBERS_VOLUNTARY_LIQUIDATION";
    TradingStatus["OUT_OF_BUSINESS"] = "OUT_OF_BUSINESS";
    TradingStatus["RECEIVER_APPOINTMENT"] = "RECEIVER_APPOINTMENT";
    TradingStatus["RECEIVER_CESSATION"] = "RECEIVER_CESSATION";
    TradingStatus["VOLUNTARY_ARRANGEMENT_COMPLETED"] = "VOLUNTARY_ARRANGEMENT_COMPLETED";
    TradingStatus["VOLUNTARY_ARRANGEMENT_IN_EFFECT"] = "VOLUNTARY_ARRANGEMENT_IN_EFFECT";
    TradingStatus["VOLUNTARY_ARRANGEMENT_REVOKED"] = "VOLUNTARY_ARRANGEMENT_REVOKED";
    TradingStatus["VOLUNTARY_LIQUIDATION"] = "VOLUNTARY_LIQUIDATION";
    TradingStatus["WINDING_UP_ORDER"] = "WINDING_UP_ORDER";
    TradingStatus["WINDING_UP_PETITION_DISMISSED"] = "WINDING_UP_PETITION_DISMISSED";
    TradingStatus["WINDING_UP_PETITION_FILED"] = "WINDING_UP_PETITION_FILED";
    TradingStatus["WINDING_UP_RESOLUTION"] = "WINDING_UP_RESOLUTION";
})(TradingStatus || (TradingStatus = {}));
registerEnum(TradingStatus, 'TradingStatus');
export { TradingStatus };
//# sourceMappingURL=TradingStatus.js.map